import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Star, Trophy } from "lucide-react";

export default function PublicPlayers() {
  const [players, setPlayers] = useState([]);
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    const load = async () => {
      const club = await api.get("/public/clubs/by-name/ASSMBB");

      const [playersRes, teamsRes] = await Promise.all([
        api.get(`/public/clubs/${club.data.id}/players`),
        api.get(`/public/clubs/${club.data.id}/teams`),
      ]);

      const playersData = Array.isArray(playersRes.data)
        ? playersRes.data
        : playersRes.data.items || playersRes.data.players || [];

      const teamsData = Array.isArray(teamsRes.data)
        ? teamsRes.data
        : teamsRes.data.items || teamsRes.data.teams || [];

      setPlayers(playersData);
      setTeams(teamsData);
    };

    load();
  }, []);

  const teamName = (id) => teams.find((t) => t.id === id)?.name || "—";
  const teamCategory = (id) => teams.find((t) => t.id === id)?.category || "";

  const showcasedPlayers = players.filter((p) => {
    const category = teamCategory(p.team_id);
    return (
      category === "N1A" ||
      p.is_captain === true ||
      p.is_featured === true ||
      p.featured === true ||
      p.is_top_player === true
    );
  });

  const list = showcasedPlayers.slice(0, 12);

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
      <div className="text-xs uppercase tracking-[0.3em] text-orange-500 font-bold mb-3">
        Joueurs mis en avant
      </div>

      <h1 className="font-display text-4xl lg:text-5xl font-black mb-4">
        Nos joueurs
      </h1>

      <p className="text-slate-600 mb-10 max-w-3xl">
        Cette page met en avant les joueurs N1A, les capitaines et les profils sélectionnés par le club.
        Les catégories jeunes ne sont pas affichées publiquement par défaut.
      </p>

      {list.length === 0 ? (
        <div className="bg-orange-50 border border-orange-100 rounded-2xl p-6 text-slate-700">
          Aucun joueur mis en avant pour le moment. Le club pourra sélectionner les joueurs à afficher publiquement.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {list.map((p) => (
            <div key={`${p.team_id}:${p.last_name}:${p.first_name}:${p.jersey_number ?? ""}`} className="bg-white border border-slate-200 rounded-2xl overflow-hidden hover:shadow-lg transition">
              <div className="bg-slate-100 h-48 flex items-center justify-center text-slate-400">
                <div className="font-display text-5xl font-black text-slate-300" aria-hidden="true">
                  {p.first_name?.[0]}{p.last_name?.[0]}
                </div>
              </div>

              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  {teamCategory(p.team_id) === "N1A" && (
                    <span className="bg-orange-100 text-orange-700 text-xs font-bold rounded-full px-2 py-1 flex items-center gap-1">
                      <Trophy className="w-3 h-3" /> N1A
                    </span>
                  )}
                  {(p.is_captain || p.is_featured || p.featured) && (
                    <span className="bg-slate-100 text-slate-700 text-xs font-bold rounded-full px-2 py-1 flex items-center gap-1">
                      <Star className="w-3 h-3" /> Sélection
                    </span>
                  )}
                </div>

                <div className="text-xs uppercase tracking-widest text-orange-500 font-bold">
                  #{p.jersey_number || "—"}
                </div>

                <h3 className="font-display text-lg font-bold mt-0.5">
                  {p.last_name?.toUpperCase()}<br />{p.first_name}
                </h3>

                <div className="text-xs text-slate-500 mt-1">
                  {p.position || "—"} · {teamName(p.team_id)}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
